import { render } from "./expiring-points.vue?vue&type=template&id=092a5052&ts=true"
import script from "./expiring-points.vue?vue&type=script&lang=ts"
export * from "./expiring-points.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__